import React, { useCallback, useEffect, useState } from 'react'
import { DI, DIProps } from '../../../../../Core';
import { Select as PolarisSelect, TextField, BlockStack } from '@shopify/polaris';
import { amazonStatusOpt, optionsForTags, priceSelectOpt, shopifyStatusOpt, statusPlatformOpt, syncStatusOpt } from '../../Utils/Constants';
import RenderCreatedAtFilter from './RenderCreatedAtFilter';
import { useTranslation } from 'react-i18next';
import CustomFilter from '../../../../../Libs/CustomFilters/CustomFilter';
import { useSearchParams } from 'react-router-dom';
import { OrderFilterI } from '../../Utils/Interface';
interface props extends DIProps {
    filter: OrderFilterI
    setFilter: (data: OrderFilterI) => void
    appliedFilters: any
    setappliedFilters: (data: any) => void
    selected: string[]
    setSelected: (val: string[]) => void
    handleQueryValueRemove: (key: string) => void
    inputValue: string
    setInputValue: (val: string) => void
    handleTabChange:(e:any)=>void
}

const RenderFilters = (props: props) => {
    const { t } = useTranslation();
    const { statusPlatformOption } = statusPlatformOpt();
    const { amazonStatusOption } = amazonStatusOpt();
    const { shopifyStatusOption } = shopifyStatusOpt();
    const { priceSelectOption } = priceSelectOpt();
    const { syncStatusOption } = syncStatusOpt();
    const { filter, setFilter, appliedFilters, setappliedFilters, selected, setSelected, handleQueryValueRemove, handleTabChange,inputValue, setInputValue } = props;
    const [orderFilter, setOrderFilter] = useState<Array<any>>([]);
    const [searchParams, setSearchParams] = useSearchParams();

    // use-effect to create filter structures and handle them
    useEffect(() => {
        let tempFilter: any = [];
        let temp: any = { ...filter };
        if (searchParams.get('shipment_error')) {
            temp['Sync Status']['value'] = "failed_shipment";
            temp['Sync Status']['label'] = 'Failed Shipment'
            temp['Sync Status']['textValue'] = true
            temp['Sync Status']['change'] = true;
            temp['Sync Status']['selectValue'] = '10'
            searchParams.delete('shipment_error');
            setSearchParams(searchParams);
        }
        Object.keys(temp).forEach((key: any) => {
            switch (key) {
                case "Status":
                    tempFilter[0] = {
                        key: 'Status',
                        label: t('Status'),
                        filter: (
                            <BlockStack gap="300">
                                <PolarisSelect
                                    disabled={false}
                                    label=''
                                    placeholder={`${t('Choose')}..`}
                                    options={statusPlatformOption}
                                    value={temp[key]?.platform}
                                    onChange={(value) => handleselectChange(value, key, statusPlatformOption, 'platform')}
                                />
                                <PolarisSelect
                                    disabled={temp[key]?.platform == ''}
                                    label=''
                                    placeholder={`${t('Choose')}..`}
                                    options={temp[key]?.platform === "marketplace_status" ? [...amazonStatusOption] : [...shopifyStatusOption]}
                                    value={temp[key]?.textValue}
                                    onChange={(value) => temp[key]?.platform == "marketplace_status" ? handleselectChange(value, key, amazonStatusOption) : handleselectChange(value, key, shopifyStatusOption)}
                                />
                            </BlockStack>
                        )
                    }

                case "Sync Status": {
                    tempFilter[1] = {
                        key: "Sync Status",
                        label: t("Sync Status"),
                        filter: (
                            <PolarisSelect
                                disabled={false}
                                label=""
                                placeholder={`${t('Choose')}..`}
                                value={temp[key].value}
                                options={syncStatusOption}
                                onChange={(value) => handleselectChange(value, key, syncStatusOption)}
                            />
                        )
                    }
                }

                case "Price": {
                    tempFilter[2] = {
                        key: "Price",
                        label: t("Price"),
                        filter: (
                            <BlockStack gap="200">
                                <PolarisSelect
                                    label=""
                                    placeholder=""
                                    options={priceSelectOption}
                                    value={temp[key]?.selectValue}
                                    onChange={(value) => {
                                        temp[key]['selectValue'] = value
                                        if (temp[key]['textValue'] !== "")
                                            props.di.globalState.set('orders_filter', JSON.stringify(temp), true)
                                        setFilter({ ...temp })

                                    }}
                                />
                                <TextField
                                    min="0"
                                    placeholder={t("enter value")}
                                    type="number"
                                    labelHidden
                                    autoComplete="off"
                                    label={undefined}
                                    value={temp[key]?.textValue}
                                    onChange={
                                        (value) => {
                                            temp[key]['textValue'] = value
                                            temp[key]['change'] = value.trim() != "" ? true : false
                                            props.di.globalState.set('orders_filter', JSON.stringify(temp), true)
                                            setFilter({ ...temp })
                                        }
                                    }

                                />
                            </BlockStack>)
                    }
                }

                case 'Tags': {
                    tempFilter[3] = {
                        key: 'Tags',
                        label: t('Tags'),
                        filter: (
                            <PolarisSelect
                                disabled={false}
                                label=""
                                placeholder={`${t("Choose")}..`}
                                value={temp[key]?.textValue}
                                options={optionsForTags}
                                onChange={(value) => handleselectChange(value, key, optionsForTags)} />
                        )
                    }
                }

                case "Order Date": {
                    tempFilter[4] = {
                        key: "Order Date",
                        label: t("Order created on Amazon"),
                        filter: <RenderCreatedAtFilter filter={filter} setFilter={setFilter} selected={selected} setSelected={setSelected} />
                    }
                }
            }
        })

        setOrderFilter(tempFilter);
    }, [filter, selected])

    /**
     * Handles the change in select input values and updates the filter state
     * @param {string | any} value The value of the select input
     * @param {string} keyFilter The key of the filter
     * @param {any} options The options for the select input
     * @param {string | undefined} type The type of select input
     */
    const handleselectChange = useCallback((value: string | any, keyFilter: string, options: any, type?: string) => {
        let tempData = { ...filter }
        handleTabChange(0)
        Object.keys(tempData).map(key => {
            if (key == keyFilter && keyFilter == "Tags") {
                tempData[key]['textValue'] = value;
                tempData[key]['change'] = true;
                tempData[key]['value'] = "filter_tags";
                tempData[key]['label'] = options.filter((valueFilter: any) => { return valueFilter.value == value })[0]['label']
                props.di.globalState.set('orders_filter', JSON.stringify(tempData), true)
                setFilter({ ...tempData })
            }
            else if (key == keyFilter && keyFilter == "Status") {

                if (type && type === 'platform') {
                    tempData[key]['platform'] = options.filter((valueFilter: any) => { return valueFilter.value == value })[0]['value'];
                    tempData[key]['label'] = options.filter((valueFilter: any) => { return valueFilter.value == value })[0]['label'];
                    tempData[key]['textValue'] = ''
                }
                else {
                    tempData[key]['change'] = true;
                    tempData[key]['textValue'] = options.filter((valueFilter: any) => { return valueFilter.value == value })[0]['value'];
                    tempData[key]['label2'] = options.filter((valueFilter: any) => { return valueFilter.value == value })[0]['label'];
                    props.di.globalState.set('orders_filter', JSON.stringify(tempData), true)
                }
                setFilter({ ...tempData })
            }
            else if (key === keyFilter && key === 'Sync Status') {
                tempData[key]['value'] = value;
                tempData[key]['label'] = options.filter((valueFilter: any) => valueFilter.value == value)[0]['label']
                tempData[key]['textValue'] = options.filter((valueFilter: any) => valueFilter.value == value)[0]['key']
                tempData[key]['change'] = true;
                if (tempData[key]['label'] === 'Failed Order') tempData[key]['selectValue'] = '1'
                if (tempData[key]['label'] === 'Failed Shipment') tempData[key]['selectValue'] = '10'
                if (tempData[key]['label'] === 'Failed Refund') tempData[key]['selectValue'] = '3'
                if (tempData[key]['label'] === 'Failed Cancellation') tempData[key]['selectValue'] = '1'
                if (tempData[key]['label'] === 'Refunded') tempData[key]['selectValue'] = '3'
                if (tempData[key]['label'] === 'Created') tempData[key]['selectValue'] = '1'
                if (tempData[key]['label'] === 'Cancelled') tempData[key]['selectValue'] = '1'
                props.di.globalState.set('orders_filter', JSON.stringify(tempData), true)
                setFilter({ ...tempData })
            }
        })
    }, [])

    /**
     * function to clear all filters
     */
    const handleClearAllFilters = useCallback(() => {
        let tempData = { ...filter }
        Object.keys(tempData).map(key => {
            if (tempData[key].change) {
                tempData[key].textValue = ''
                tempData[key].change = false
                if (key === 'Sync Status') tempData[key]['value'] = ''
                if (tempData[key].hasOwnProperty('label')) tempData[key]['label'] = '';
                if (tempData[key].hasOwnProperty('label2')) tempData[key]['label2'] = '';
                if (tempData[key].hasOwnProperty('platform')) tempData[key]['platform'] = '';
            }
        })
        setFilter(tempData)
        setSelected(["Select Date"]);
        props.di.globalState.removeLocalStorage('orders_filter')
        setappliedFilters([])
    }, [])
    return (
        <React.Fragment>
            {
                orderFilter.length > 0 &&
                <div style={{ flex: '0 0 auto' }}>
                    <CustomFilter
                        filters={orderFilter}
                        appliedFilters={Object.values(appliedFilters)}
                        onClearAll={handleClearAllFilters}
                        btnText={t('More filters')}
                        handleRemoveFilter={handleQueryValueRemove}
                        searchValue={inputValue}
                        handleSearchbar={(e) => {
                            e = e.toString().replace(/[!$%^&*()@+|~=`\\#{}\[\]:";'<>?,.\/_]/gi, "");
                            e = e.toString().replace("--", "-");
                            searchParams.delete('orderId');
                            setSearchParams(searchParams);
                            setInputValue(e)
                        }}
                        placeholder={t("Search using the Amazon order ID")}
                        clearSearchBar
                        onClearFunction={() => setInputValue('')}
                    />
                </div>
            }
        </React.Fragment>
    )
}

export default DI(RenderFilters)